module.exports = __webpack_public_path__ + "YoungSerif-Regular.c9dc812e61c61b71752d.eot";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/YoungSerif-Regular.eot
// module id = ../../../../../src-admin/assets/fonts/YoungSerif-Regular.eot
// module chunks = styles